/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_DescInputs */

const en_cp_pricing_desc = /** @type {(inputs: Cp_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Builder & Problem Solver program for student teams; classes and campuses are invoiced.`)
};

const id_cp_pricing_desc = /** @type {(inputs: Cp_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program Builder & Problem Solver untuk tim mahasiswa; kelas dan kampus lewat invoice.`)
};

/**
* | output |
* | --- |
* | "The Builder & Problem Solver program for student teams; classes and campuses are invoiced." |
*
* @param {Cp_Pricing_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_desc = /** @type {((inputs?: Cp_Pricing_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_desc(inputs)
	return en_cp_pricing_desc(inputs)
});